import { useEffect, lazy } from 'react';
import { useSelector } from 'forms-ai-lib/internal/hooks/redux';
import usePrevious from 'react-utils/hooks/usePrevious';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { trackEvent } from 'forms-ai-lib/internal/utils/usageTracker';
import { useSettleResultPromise } from 'forms-ai-lib/internal/providers/ResultPromiseContext';
import { SuspenseWithErrorBoundary } from 'forms-ai-lib/internal/components/SuspenseWithErrorBoundary';
import { FullScreenErrorElement } from 'forms-ai-lib/internal/components/FullScreenErrorElement';
import { selectIsOpen, selectMode } from 'forms-ai-lib/internal/selectors/config';
import { useStableFunction } from 'forms-ai-lib/internal/hooks/useStableFunction';
import { useCreateCustomAgentActionWizard } from 'forms-ai-lib/hooks/experimental/useCreateCustomAgentActionWizard';
import { useFormAIWizard } from 'forms-ai-lib/hooks/useFormAIWizard';
import { TRACKING_EVENT_ACTIONS } from 'forms-ai-lib/internal/constants';
import { jsx as _jsx } from "react/jsx-runtime";
const AsyncCreateFormAIWizard = /*#__PURE__*/lazy(() => import('forms-ai-lib/internal/wizards/CreateFormAIWizard'));
const AsyncCreateCustomerAgentWizard = /*#__PURE__*/lazy(() => import('forms-ai-lib/internal/wizards/CreateCustomerAgentWizard'));
export const WizardContainer = () => {
  const isOpen = useSelector(selectIsOpen);
  const mode = useSelector(selectMode);
  const settleResultPromise = useSettleResultPromise();
  const {
    closeCreateCustomerAgentActionWizard
  } = useCreateCustomAgentActionWizard();
  const {
    closeFormAIWizard
  } = useFormAIWizard();
  const previousIsOpen = usePrevious(isOpen);
  useEffect(() => {
    if (isOpen && previousIsOpen !== isOpen) {
      trackEvent('settingsInteraction', {
        action: TRACKING_EVENT_ACTIONS.OPEN_MODAL
      });
    }
  }, [isOpen, previousIsOpen]);
  const handleCloseComplete = useStableFunction(() => {
    if (isOpen) {
      return;
    }
    trackEvent('settingsInteraction', {
      action: TRACKING_EVENT_ACTIONS.CLOSE_MODAL
    });
    settleResultPromise();
  });
  if (!isOpen) {
    return null;
  }
  if (mode === 'CUSTOMER_AGENT') {
    return /*#__PURE__*/_jsx(Modal, {
      "data-test-id": "create-customer-agent-wizard",
      use: "fullscreen",
      onEsc: closeCreateCustomerAgentActionWizard,
      onCloseComplete: handleCloseComplete,
      children: /*#__PURE__*/_jsx(SuspenseWithErrorBoundary, {
        errorElement: /*#__PURE__*/_jsx(FullScreenErrorElement, {}),
        children: /*#__PURE__*/_jsx(AsyncCreateCustomerAgentWizard, {})
      })
    });
  }
  return /*#__PURE__*/_jsx(Modal, {
    "data-test-id": "create-form-ai-wizard",
    use: "fullscreen",
    onEsc: closeFormAIWizard,
    onCloseComplete: handleCloseComplete,
    children: /*#__PURE__*/_jsx(SuspenseWithErrorBoundary, {
      errorElement: /*#__PURE__*/_jsx(FullScreenErrorElement, {}),
      children: /*#__PURE__*/_jsx(AsyncCreateFormAIWizard, {})
    })
  });
};